import { Component } from '@angular/core';

@Component({
  selector: 'app-ops-inventory',
  imports: [],
  templateUrl: './ops-inventory.html',
  styleUrl: './ops-inventory.scss'
})
export class OpsInventory {

}
